import { FormatPhonePipe } from '../../../modules/mapfre-design-library/src/lib/_helpers/_pipes/format-phone.pipe';
import { MapfreLoadingComponent } from '../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-loading/mapfre-loading.component';
import { LiabilitySvgComponent } from '../../../modules/mapfre-design-library/src/lib/svg/liability-svg/liability-svg.component';
import { GarageSvgComponent } from '../../../modules/mapfre-design-library/src/lib/svg/garage-svg/garage-svg.component';
import { DwellingFireSvgComponent } from '../../../modules/mapfre-design-library/src/lib/svg/dwelling-fire-svg/dwelling-fire-svg.component';
import { UmbrellaSvgComponent } from '../../../modules/mapfre-design-library/src/lib/svg/umbrella-svg/umbrella-svg.component';
import { HouseMonoColorSmallSvgComponent } from '../../../modules/mapfre-design-library/src/lib/svg/house-mono-color-small-svg/house-mono-color-small-svg.component';
import { CarMonoColorSmallSvgComponent } from '../../../modules/mapfre-design-library/src/lib/svg/car-mono-color-small-svg/car-mono-color-small-svg.component';
import { MapfreInfoDivsComponent } from '../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-info-divs/mapfre-info-divs.component';
import { BillingQuestionComponent } from '../../dashboard/loggedin-content/billing/billing-question/billing-question.component';
import { MapfreCardComponent } from '../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { PolicyDataService } from './../../../_services/data-services/policy-data.service';
import * as _ from 'underscore';
import { ContactService } from '../../../_services/misc-services/contact.service';
import { ModalOptions, AcmicService } from '@mapfre-design-library/src/public_api';
import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';
import { CompanyService } from '@services/my-insurance/company.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreCardComponent, BillingQuestionComponent, MapfreInfoDivsComponent, CarMonoColorSmallSvgComponent, HouseMonoColorSmallSvgComponent, UmbrellaSvgComponent, DwellingFireSvgComponent, GarageSvgComponent, LiabilitySvgComponent, MapfreLoadingComponent, FormatPhonePipe],
  selector: 'app-contact-screen',
  templateUrl: './contact-screen.component.html',
  styleUrls: ['./contact-screen.component.scss'],
  providers: [ContactService],
})
export class ContactScreenComponent implements OnInit {
  policies: any;
  loading: boolean;
  policyType: any;
  livoNumber = false;
  as400Number = false;
  both = false;
  allLivoPolicy: any = [];
  sendQuestionModal: ModalOptions;
  isApp = false;
  isAcmic: boolean;
  showCompany: string;

  constructor(
    private policyDataService: PolicyDataService,
    private contactService: ContactService,
    private acmicService: AcmicService,
    private companyService: CompanyService
  ) {
    this.sendQuestionModal = new ModalOptions({
      additionalClasses: 'modal-medium cancel-enroll modal-dialog',
      additionalButtonClasses: 'ghost tertiary small',
      buttonCopy: 'SEND_QUESTION',
      modalId: 'sendQuestion',
      modalTranslateCopy: 'Send billing question',
      modalName: 'contact-screen_Billing_Question',
    });
  }

  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
    this.loading = true;
    this.companyService.$currentCompany.subscribe((company) => {
      this.showCompany = company;
    });

    this.policyDataService.$policyDetails.subscribe((allPolicies) => {
      const policyDetails: any = [];
      if (allPolicies) {
        const convertedPolicies = [];
        allPolicies.forEach((p) => {
          if (p.isConverted && p.legacyPolicyNumber) {
            convertedPolicies.push(p.legacyPolicyNumber);
          }
        });
        const nonConvertedPolicies = allPolicies.filter(
          (policy) =>
            !convertedPolicies.includes(policy.policynumber.policyNumber)
        );
        const groupArray = _.groupBy(
          nonConvertedPolicies,
          (policy) => policy.agent.agentName
        );
        Object.keys(groupArray).forEach((policy) => {
          policyDetails.push(groupArray[policy]);
        });
        this.policies = policyDetails;
        this.policyType = _.keys(
          _.groupBy(
            _.pluck(
              _.pluck(nonConvertedPolicies, 'policynumber'),
              'policyNumber'
            ),
            'length'
          )
        );

        this.contactService.dynamicContact(
          nonConvertedPolicies,
          this.policyType
        );
        this.as400Number = this.contactService.as400Number;
        this.livoNumber = !this.contactService.as400Number && !this.contactService.livoNumber ? true : this.contactService.livoNumber;
        this.both = this.contactService.both;
        this.allLivoPolicy = this.contactService.allLivoPolicy;
        this.loading = false;
      }
    });

    if (Capacitor.isNativePlatform()) {
      this.isApp = true;
    }
  }

  onClickSocialMedia(link) {
    Browser.open({ url: link });
  }
}
